<template>
  <div class="page-wrapper">
    <Title title="加入九吨"></Title>
    <div class="wrapper-box">
      <div class="item" v-for="item in list" :key="item.id">
        <img :src="item.resource" class="img" alt="">
        <h2 class="title">{{ item.title }}</h2>
        <div class="btn ajc" @click="look(item.extends)">
          查看职位
        </div>
      </div>
    </div>
    <!-- footer -->
    <div class="footer">
      <div class="ac space-between item" @click="go('/mobile/welfare')">
        <span>九吨福利</span><span>+</span>
      </div>
      <div class="ac space-between item" @click="go('/mobile/contact')">
        <span>联系九吨</span><span>+</span>
      </div>

      <!-- copyright -->
      <div class="copyright">
        {{ info.copyright }}
      </div>
    </div>
  </div>
</template>

<script>
import Title from '@/components/mobile/Title'
export default {
  components: {
    Title
  },
  data() {
    return {
      list: [],
      info: {}
    }
  },
  mounted() {
    this.getData()
    this.getinfo()
  },
  methods: {
    look(url) {
      // window.open(url)
      window.location.href = url
    },
    go(path) {
      this.$router.push(path)
    },
    async getData() {
      const [err, res] = await this.$http.get('jobs')
      if (err) return
      this.list = res.list
    },
    async getinfo() {
      const [err, res] = await this.$http.get('info')
      if (err) return
      this.info = res
    },
  }
}
</script>

<style lang="less" scoped>
.page-wrapper {
  position: relative;
  height: 100%;
}

.wrapper-box {
  margin-top: 2.84rem;
  // display: flex;
  white-space: nowrap;
  overflow: auto;

  &::-webkit-scrollbar {
    display: none;
  }

  .item {
    width: 3.3067rem;
    height: 5.44rem;
    margin-right: 0.926rem;
    margin-bottom: 1.0667rem;
    display: inline-block;
    // border: 1px solid;



    .img {
      width: 100%;
      height: 3.5467rem;
      margin-bottom: .4533rem;
    }

    .title {
      font-size: .4267rem;
      text-align: center;
      margin-bottom: .24rem;
    }

    .btn {
      width: 2.5067rem;
      height: .6rem;
      border-radius: .3067rem;
      border: 1px solid #979797;
      font-size: .32rem;
      margin: 0 auto;
    }
  }
}

.footer {
  position: absolute;
  width: 9.1333rem;
  bottom: .8rem;
  left: 50%;
  transform: translate(-50%);
  font-size: .3733rem;

  .item {
    width: 100%;
    border-bottom: 1px solid rgba(151, 151, 151, 0.3);
    padding-bottom: .2667rem;
    margin-bottom: .2933rem;
  }

  .copyright {
    text-align: center;
    color: #666;
    font-size: .2933rem;
  }
}</style>